import styled from 'styled-components';
import { Icon } from '../../../Icon';
import { PictureContainer } from '../../../media/PictureContainer';

export const Wrapper = styled.div`
  display: flex;
`;

export const IconStyled = styled(Icon).attrs({
  size: 'small'
})`
  line-height: 0;
  margin-right: 0.8rem;
`;

export const Image = styled(PictureContainer)`
  flex-shrink: 0;
  height: 2.4rem;
  margin-right: 0.4rem;
  margin-left: auto;
`;
